import Page from "../Page/Page";
import "../../Styles/hisstoriKnowledge.css";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { Transaction_KnowledgeExam } from "../../Connections/Transaction";
import ExamModalCart from "../../Components/Alerts/ExamModalCart";

const Knowledge = () => {
  const navigate = useNavigate();
  const [examList, setExamList] = useState([]);

  //get knowledge exams
  useEffect(() => {
    Transaction_KnowledgeExam.GetKnowledgeExams()
      .then((res) => {
        if (res[0]) {
          setExamList(res[2].data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  //exam modal status
  const [examModalStatus, setExamModalStatus] = useState(false);

  //route to Exam
  const [routeInfo, setRouteInfo] = useState({
    id: "",
    bookName: "",
    remainedExam: "",
  });

  const handleOpenModalExam = (id, bookName, remainedExam) => {
    setRouteInfo({
      id,
      bookName,
      remainedExam,
    });
    setExamModalStatus(true);
  };

  const handleRouteToExam = () => {
    navigate(`/hisstori/knowledge/examination/${routeInfo.id}`, {
      state: { bookName: routeInfo.bookName },
    });
  };

  return (
    <>
      <Page>
        <div className="wrapper_hisstoriKnowledge">
          <div style={{ position: "relative" }}>
            <img
              className="header-bg-stars mobile-hidden"
              src={
                "https://ketabno.com/static/media/first-section-background.5913a5be96843bbb494e.svg"
              }
              alt="bg"
            />
            <img
              className="desktop-hidden header-star-mobile"
              src={"/imgs/ambassadors/1000000952.svg"}
              alt="bg"
            />
          </div>
          <section className="hisstori-knowledge-section-top">
            <img
              src="/imgs/hisstoriPlus/savad-hisstori.svg"
              alt="knowledgeBanner"
            />
            <h1>مسابقه سواد هیس‌طوری</h1>
            <p className="desc-hissotiPlus-headSection">
              سواد هیس‌طوری، یه مسابقه‌ی سخت و ویژه‌ست برای اونایی که همه‌ی
              کتاب‌های سرگذشت استعمار رو قورت دادن :)
            </p>
          </section>
          <section className="book-card-knowledge-parent">
            {/* card box */}
            {examList.map((item) => {
              return (
                <div key={item.id} className="book-knowledge-card">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      className="book-knowledge-card-banner"
                      src={item.pic}
                      alt="book-image"
                    />
                    <h3 className="book-knowledge-card-title">{item.title}</h3>
                    <p className="book-knowledge-card-desc">{item.book}</p>
                  </div>
                  <div style={{ width: "100%" }}>
                    {item.yourScore > 0 ? (
                      <div className="book-knowledge-card-diamond-box">
                        <span>
                          {`تونستی ${item.yourScore} امتیاز از این آزمون بگیری`}
                        </span>
                        <img
                          src="/imgs/bashgah/bashgah-group.svg"
                          alt="diamond-image"
                        />
                      </div>
                    ) : (
                      <div
                        style={{ marginTop: "10px" }}
                        className="book-knowledge-card-diamond-box-parent"
                      >
                        <div className="book-knowledge-card-diamond-box">
                          <span>15 سوال</span>
                          <img
                            src="/imgs/hisstoriPlus/exam-icon.svg"
                            alt="diamond-image"
                          />
                        </div>
                        <div className="book-knowledge-card-diamond-box">
                          <span>{item.allScore} امتیاز</span>
                          <img
                            src="/imgs/bashgah/bashgah-group.svg"
                            alt="diamond-image"
                          />
                        </div>
                      </div>
                    )}
                    {item.isActive === false ? (
                      <div
                        style={{ backgroundColor: "#99A1E5" }}
                        className="book-knowledge-card-exam-box"
                      >
                        <span>این آزمون به زودی فعال می‌شه :)</span>
                        <img
                          src="/imgs/hisstoriPlus/lock-icon.svg"
                          alt="diamond-image"
                        />
                      </div>
                    ) : item.isSuccess === true ? (
                      <div
                        style={{ backgroundColor: "#483C97" }}
                        className="book-knowledge-card-exam-box"
                      >
                        <span>آفرین! این آزمون رو با موفقیت گذروندی</span>
                        <img
                          src="/imgs/hisstoriPlus/lock-icon.svg"
                          alt="diamond-image"
                        />
                      </div>
                    ) : item.remainedExam === 0 ? (
                      <div
                        style={{ backgroundColor: "#FB6161" }}
                        className="book-knowledge-card-exam-box"
                      >
                        <span>دیگه نمی‌تونی برای این آزمون تلاش کنی</span>
                        <img
                          src="/imgs/hisstoriPlus/lock-icon.svg"
                          alt="diamond-image"
                        />
                      </div>
                    ) : (
                      <div
                        onClick={() =>
                          handleOpenModalExam(
                            item.id,
                            item.book,
                            item.remainedExam
                          )
                        }
                        style={
                          item.remainedExam < item.allowAttempt
                            ? { backgroundColor: "#02948A", cursor: "pointer" }
                            : { backgroundColor: "#AF41C6", cursor: "pointer" }
                        }
                        className="book-knowledge-card-exam-box"
                      >
                        <span>
                          {item.remainedExam < item.allowAttempt
                            ? "هنوز می‌تونی برای این آزمون تلاش کنی"
                            : "می‌تونی این آزمون رو شروع کنی"}
                        </span>
                        <img
                          src="/imgs/hisstoriPlus/unlock-icon.svg"
                          alt="diamond-image"
                        />
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </section>
        </div>
      </Page>
      {examModalStatus && (
        <ExamModalCart
          handleRoute={() => handleRouteToExam()}
          close={() => setExamModalStatus(false)}
          image={"/imgs/hisstoriPlus/examPic.svg"}
          remainedExam={routeInfo.remainedExam}
        />
      )}
    </>
  );
};

export default Knowledge;
